import React, { useState } from 'react';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BoardProvider } from './context/BoardContext';
import TopBar from './components/TopBar';
import BoardView from './components/BoardView';
import TasksView from './components/TasksView';
import AnalyticsView from './components/AnalyticsView';
import AdminUsersView from './components/AdminUsersView';
import LoginPage from './components/LoginPage';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
import { Loader2 } from 'lucide-react';

const AppContent = () => {
  const { isAuthenticated } = useAuth();
  const [view, setView] = useState('board');
  const [tasksFilter, setTasksFilter] = useState(null);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="h-5 w-5 animate-spin" />
          Loading…
        </div>
      </div>
    );
  }

  if (isAuthenticated === false) {
    return <LoginPage />;
  }

  const handleNavigate = (target, opts) => {
    setView(target);
    if (target === 'tasks' && opts?.statusFilter) {
      setTasksFilter(opts.statusFilter);
    } else {
      setTasksFilter(null);
    }
  };

  const handleViewChange = (v) => {
    setView(v);
    if (v !== 'tasks') setTasksFilter(null);
  };

  return (
    <BoardProvider>
      <div className="min-h-screen bg-slate-50">
        <TopBar activeView={view} onViewChange={handleViewChange} />
        <ErrorBoundary key={view}>
          <main>
            {view === 'board' && <BoardView onNavigate={handleNavigate} />}
            {view === 'tasks' && <TasksView initialFilter={tasksFilter} />}
            {view === 'analytics' && <AnalyticsView />}
            {view === 'admin' && <AdminUsersView />}
          </main>
        </ErrorBoundary>
        <Toaster />
      </div>
    </BoardProvider>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
